import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_p4ik7ym3: FaireBrandEntity = {
  token: "b_p4ik7ym3",
  type: "brand",
  name: "Britta Ambauen Jewelry",
  avatarUrl: "https://cdn.faire.com/fastly/f4eff4087bc287710b06417e8e1ca63fc9eb3acc13913171d0356d4c44f5f27a.jpeg",
  bannerUrl: "https://cdn.faire.com/fastly/c75f99bfe5ad79aeaaa5e72bdbfdd331e2d6265e52f6016a1126d7cb4cdda5d4.jpeg",
  logoUrl: "https://cdn.faire.com/fastly/f4eff4087bc287710b06417e8e1ca63fc9eb3acc13913171d0356d4c44f5f27a.jpeg",
  heroImageUrl: "https://cdn.faire.com/fastly/c75f99bfe5ad79aeaaa5e72bdbfdd331e2d6265e52f6016a1126d7cb4cdda5d4.jpeg",
  location: "Seattle, WA, USA",
  minimumOrderDollars: 150,
  rating: 4.9,
  reviewCount: 50,
  isTopShop: true,
  isInsider: true,
  description: "With a background in women’s outdoor leadership and a lifelong pursuit of the arts, company founder Britta Ambauen was inspired to create a jewelry line that connected the wearer with her intentions of cultivating a fulfilling life. Founded in 2009, her eponymous jewelry line has grown organically over the years with a continued deepening of the founding vision. As the line enters its 14th year, we seek to reach even greater audiences with our inspired messages of personal growth, presence, and challenging oneself to face moments of opportunity with an attitude of courage.",
  meta: {
    source: "api",
    importedAt: "2026-10-07T18:32:29.258Z",
    importedBy: "entity-db-cli"
  }
};
